import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Home.vue'
import AboutPage from '@/views/AboutPage.vue'
import ProductsPage from '@/views/ProductsPage.vue'
import ProductDetailPage from '@/views/ProductDetailPage.vue'
import QualityPage from '@/views/QualityPage.vue'
import FaqPage from '@/views/FaqPage.vue'
import ContactPage from '@/views/ContactPage.vue'
import AddFriendPage from '@/views/AddFriendPage.vue'
import { resolveLegacyHash } from '@/content/siteContent.mjs'

// 每条路由都对应构建产物里的一个真实 .html 文件，静态托管无需路由重写。
const routes = [
  { path: '/', name: 'Home', component: HomeView },
  { path: '/index.html', redirect: '/' },
  { path: '/about.html', name: 'About', component: AboutPage },
  { path: '/products.html', name: 'Products', component: ProductsPage },
  { path: '/products/:id(shihu1|shihu2|shihu3).html', name: 'ProductDetail', component: ProductDetailPage },
  { path: '/quality.html', name: 'Quality', component: QualityPage },
  { path: '/faq.html', name: 'Faq', component: FaqPage },
  { path: '/contact.html', name: 'Contact', component: ContactPage },
  { path: '/add-friend.html', name: 'AddFriend', component: AddFriendPage }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, top: 80 }
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  const rewritten = resolveLegacyHash(to.fullPath)
  return rewritten === to.fullPath ? true : rewritten
})

export default router
